import * as React from 'react';

import { Tag } from '@coursera/cds-core';
import { AIGenerateIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/compound-assessments';

const AiGradedTag = () => {
  return (
    <div>
      <Tag variant="status" priority="secondary" icon={<AIGenerateIcon size="small" />}>
        {_t('AI-graded')}
      </Tag>
    </div>
  );
};

export default AiGradedTag;
